import { ApplicationInsights, DistributedTracingModes } from '@microsoft/applicationinsights-web';
import { signedInUser } from '@ctm/auth/store';
import { browser, version } from '$app/environment';
import { navigating } from '$app/stores';

/** @type {ApplicationInsights | null} */
export let appInsights = null;
let currentUser = null;

export const track = {
	/** @type {typeof appInsights['trackPageView']} */
	pageView(telemetry) {
		telemetry.properties = {
			...telemetry.properties,
			user: currentUser,
		};
		if (appInsights === null) {
			console.log('[track:pageView] %o', telemetry);
			return;
		}
		return appInsights.trackPageView(telemetry);
	},

	/** @type {typeof appInsights['trackEvent']} */
	event(telemetry) {
		telemetry.properties = {
			...telemetry.properties,
			user: currentUser,
		};
		if (appInsights === null) {
			console.log('[track:event] %o', telemetry);
			return;
		}
		return appInsights.trackEvent(telemetry);
	},

	/** @type {typeof appInsights['trackException']} */
	exception(telemetry, customProperties) {
		customProperties = {
			...customProperties,
			user: currentUser,
		};
		if (appInsights === null) {
			console.log('[track:exception] %o %o', telemetry, customProperties);
			return;
		}
		return appInsights.trackException(telemetry, customProperties);
	},
};

export function setupAppInsights() {
	if (!browser) {
		return;
	}
	const connectionString = environmentSettings.appInsightsConnectionString;
	if (!connectionString) {
		console.warn('[AppInsights] no connection string in environment settings');
		return;
	}

	const apiUrl = new URL(environmentSettings.hostApiUrl);
	appInsights = globalThis.appInsights = new ApplicationInsights({
		config: {
			connectionString,
			/* ...Other Configuration Options... */
			enableCorsCorrelation: true,
			correlationHeaderDomains: [apiUrl.hostname],
			distributedTracingMode: DistributedTracingModes.AI,
			enableUnhandledPromiseRejectionTracking: true,
			excludeRequestFromAutoTrackingPatterns: ['api-js.mixpanel.com', 'bam.nr-data.net'],
		},
	});
	appInsights.loadAppInsights();
	appInsights.context.application.ver = version;
	appInsights.context.application.build = version;
	appInsights.addTelemetryInitializer((envelope) => {
		envelope.tags['ai.cloud.role'] = 'CTM.Portal.UI';
	});

	// Track initial page view
	track.pageView({
		uri: location.href,
		refUri: document.referrer,
	});

	navigating.subscribe((navigation) => {
		if (!navigation) {
			return;
		}
		const { from, to, type } = navigation;
		track.pageView({
			uri: to?.url.href,
			refUri: from?.url.href,
			properties: {
				routeId: to?.route.id,
				params: to?.params,
				type,
			},
		});
	});
	signedInUser.subscribe((user) => {
		if (user) {
			appInsights.setAuthenticatedUserContext(user.id);
			currentUser = {
				debtor: user.debtor,
				role: user.roleTypeName,
				roles: user.roles,
			};
		} else {
			appInsights.clearAuthenticatedUserContext();
			currentUser = null;
		}
	});
}
